<section id="services" class="section section-gradient-1 services-section">
  <div class="container">
    <h2 class="section-title">Enterprise Solutions</h2>
    <p class="section-subtitle">Comprehensive, reliable IP Telephony and data connectivity solutions tailored for your business infrastructure.</p>
    
    <div class="services-grid">
      <div *ngFor="let service of services; let i = index" class="glass-card service-card reveal-scale" [ngClass]="'delay-' + ((i % 3) + 1) * 100">
        <div class="service-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" class="service-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="service.icon" />
          </svg>
        </div>
        <h3 class="service-title">{{service.title}}</h3>
        <p class="service-desc">{{service.description}}</p>
        <div class="service-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </div>
      </div>
    </div>
  </div>
</section>
